import {
  IDynamicDiplayView,
  IDynamicSection
} from '@components/widgets/dynamic-display';
import FormattingService from '@core/services/FormattingService';

import { MarineHull } from '../types';

export function buildMarineHullDetailsView(
  data: MarineHull[]
): IDynamicDiplayView {
  return {
    name: 'PolicyMarineHullDetails',
    sections: data.map(
      (item): IDynamicSection => ({
        name: 'MarineHullDetails',
        title: 'Marine Hull Details',
        properties: {
          vesselName: {
            multiline: false,
            value: item.vesselName || '',
            name: 'vesselName',
            title: 'Vessel Name'
          },
          connectionPort: {
            multiline: false,
            value: item.connectionPort || '',
            name: 'connectionPort',
            title: 'Connection Port'
          },
          territorialWaters: {
            multiline: false,
            value: item.territorialWaters || '',
            name: 'territorialWaters',
            title: 'Territorial Waters'
          },
          usage: {
            multiline: false,
            value: item.usage || '',
            name: 'usage',
            title: 'Usage',
            sectionTitle: 'Body Details'
          },
          builder: {
            multiline: false,
            value: item.builder || '',
            name: 'builder',
            title: 'Builder',
            sectionTitle: 'Body Details'
          },
          constructionYear: {
            multiline: false,
            value: item.constructionYear || '',
            name: 'constructionYear',
            title: 'Construction Year',
            sectionTitle: 'Body Details'
          },
          registryPort: {
            multiline: false,
            value: item.registryPort || '',
            name: 'registryPort',
            title: 'Registery Number & Port',
            sectionTitle: 'Body Details'
          },
          length: {
            multiline: false,
            value: FormattingService.formatNumberWithCommas(item.length),
            name: 'length',
            title: 'Length',
            sectionTitle: 'Body Details'
          },
          weight: {
            multiline: false,
            value: FormattingService.formatNumberWithCommas(item.weight),
            name: 'weight',
            title: 'Weight',
            sectionTitle: 'Body Details'
          },
          height: {
            multiline: false,
            value: FormattingService.formatNumberWithCommas(item.height),
            name: 'height',
            title: 'Height',
            sectionTitle: 'Body Details'
          },
          engineType: {
            multiline: false,
            value: item.engineType || '',
            name: 'engineType',
            title: 'Type',
            sectionTitle: 'Engine Details'
          },
          engineNumber: {
            multiline: false,
            value: item.engineNumber || '',
            name: 'engineNumber',
            title: 'Engine Number',
            sectionTitle: 'Engine Details'
          },
          engineYearBuilt: {
            multiline: false,
            value: item.engineYearBuilt || '',
            name: 'engineYearBuilt',
            title: 'Year Built',
            sectionTitle: 'Engine Details'
          },
          engineHorsePower: {
            multiline: false,
            value: item.engineHorsePower?.toString() || '',
            name: 'engineHorsePower',
            title: 'Horse Power',
            sectionTitle: 'Engine Details'
          },
          engineMaxDesignedSpeed: {
            multiline: false,
            value: FormattingService.formatNumberWithCommas(
              item.engineMaxDesignedSpeed
            ),
            name: 'engineMaxDesignedSpeed',
            title: 'Max. Designed Speed',
            sectionTitle: 'Engine Details'
          },
          engineFuel: {
            multiline: false,
            value: item.engineFuel || '',
            name: 'engineFuel',
            title: 'Fuel',
            sectionTitle: 'Engine Details'
          },
          remarks: {
            multiline: true,
            value: item.remarks || '',
            name: 'remarks',
            title: 'Remarks',
            fullLine: true,
            sectionTitle: 'Engine Details'
          }
        }
      })
    )
  };
}
